import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Select, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from '../../axiosInstance';
import Profile from '../../components/Profile';
import Notification from '../../components/Notification';
import Input from '../../components/ui/Input';
import { FaSearch } from "react-icons/fa";

const DeleteUserPage = () => {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [collegeId, setCollegeId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {
      const res = await axios.get('https://backend.scholarkart.in/api/college-users');
      setUsers(res.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  useEffect(() => {
    fetchUsers();
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setCollegeId(user.collegeId);
    }
  }, []);

  const filteredUsers = users.filter((user) => {
    const query = inputValue.toLowerCase();
    return (
      user.username?.toLowerCase().includes(query) ||
      user.email?.toLowerCase().includes(query) ||
      user.displayname?.toLowerCase().includes(query) ||
      user.mobile?.toLowerCase().includes(query)
    );
  });

  const handleDelete = async () => {
    try {
      await axios.put(`https://backend.scholarkart.in/api/users/remove-college/${selectedUserId}`);
      setConfirmDialogOpen(false);
      navigate('/usermanagement');
    } catch (err) {
      console.error('Error removing user from college:', err);
    }
  };

  return (
    <main className="flex-grow p-1">
      <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">
        {collegeId && (
          <div className="relative w-full max-w-lg">

          </div>
        )}
        <div className="flex items-center space-x-4 relative">
          <Notification />
          <Profile />
        </div>
      </div>

      <Box p={4}>
        <Typography variant="h4" mb={4}>Delete User</Typography>

        <Select
          value={selectedUserId}
          onChange={(e) => setSelectedUserId(e.target.value)}
          fullWidth
          displayEmpty
          sx={{ mb: 2 }}
        >
          <MenuItem value="" disabled>Select user to delete</MenuItem>
          {filteredUsers.map((user) => (
            <MenuItem key={user._id} value={user._id}>
              {user.username} - {user.email}
            </MenuItem>
          ))}
        </Select>

        <Button
          variant="contained"
          color="error"
          disabled={!selectedUserId}
          onClick={() => setConfirmDialogOpen(true)}
        >
          Delete Selected User
        </Button>
      </Box>

      {/* 🛑 Confirm Dialog */}
      <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to remove this user? Anyway, You may add the user later.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleDelete} color="error" variant="contained">Confirm Delete</Button>
        </DialogActions>
      </Dialog>
    </main>
  );
};

export default DeleteUserPage;
